/**
 * The curated catalogue a vendor picks from instead of typing a product out.
 *
 * Browsing sits under /user rather than /vendor because the list is public
 * reference data — there is nothing vendor-specific in it, and the same rows back
 * the shopper-facing "known product" views.
 */
import { api } from '@/lib/api';
import type { CatalogProduct } from '@/features/commerce/types';

export type CatalogSearch = {
  vertical: 'FOOD' | 'PHARMACY';
  q?: string;
  category?: string;
  page?: number;
  page_size?: number;
};

export type CatalogListResponse = {
  items: CatalogProduct[];
  total: number;
  page: number;
  page_size: number;
};

export async function fetch_catalog_products(params: CatalogSearch): Promise<CatalogListResponse> {
  const res = await api.get<CatalogListResponse>('/user/catalog-products', { params });
  return res.data;
}

export async function fetch_catalog_product(id: string): Promise<CatalogProduct> {
  const res = await api.get<CatalogProduct>(`/user/catalog-products/${id}`);
  return res.data;
}
